// GraphQL-API pro Stage, wie im OS-Dashboard und in der universal-app. Die
// CDK-API (Stack Aivy-<stage>-Data im aivy-backend-app, Output
// awsAppsyncApiEndpoint) hat dasselbe Schema, dieselben Tabellen, denselben
// User Pool und denselben Identity Pool wie die Gen-1-API. Stages ohne Eintrag
// bleiben auf der Gen-1-API aus aws-exports.js. Zurück auf Gen 1: Eintrag
// entfernen.
//
// Maßgeblich ist nur der S3-Bucket in aws-exports.js, ohne die Fallbacks aus
// helpers/stage.js: Ist das Backend nicht eindeutig erkennbar, bleibt die
// Gen-1-API aus aws-exports.js, die passt immer zum Backend.
//
// Die CDK-API hat nur Cognito und IAM, kein API_KEY. Das Dashboard nutzt keins.
export const CDK_GRAPHQL_ENDPOINTS = {
  develop:
    'https://dsngt345fzblppniowfqhfq22a.appsync-api.eu-central-1.amazonaws.com/graphql',
  staging:
    'https://dgkmud5olngijjtcry35cj2a3i.appsync-api.eu-central-1.amazonaws.com/graphql',
  production:
    'https://iwizynmgivfppehkwb2ieeku2e.appsync-api.eu-central-1.amazonaws.com/graphql'
}

const STAGES = ['develop', 'staging', 'production']

/** Stage aus dem S3-Bucket in aws-exports.js oder null */
export const stageFromBackend = (config) => {
  const bucket = config?.aws_user_files_s3_bucket
  return STAGES.find((stage) => bucket === `aivy-user-content-${stage}`) || null
}

/** aws-exports mit dem GraphQL-Endpunkt, den die Stage nutzen soll */
export const withGraphqlApi = (config) => {
  const endpoint = CDK_GRAPHQL_ENDPOINTS[stageFromBackend(config)]
  if (!endpoint) return config
  return { ...config, aws_appsync_graphqlEndpoint: endpoint }
}
